import lineHeight from 'line-height';
import shave from 'shave';
import _debounce from 'lodash/debounce';
import breakpoints from '@/scripts/utils/breakpoints';


const height = (el) => {
  const { limitRows } = el.dataset;
  return window.innerWidth > breakpoints.lg ? lineHeight(el) * limitRows : Infinity;
};

export default function (el) {
  shave(el, height(el));
  window.addEventListener('resize', _debounce(() => {
    shave(el, height(el));
  }, 100));
}



// WEBPACK FOOTER //
// ./scripts/utils/limit-rows.js